import { IHttpClient } from "../HttpClient/IHttpClient";
import { Fetch } from "../HttpClient/FetchImplementation/Fetch";
import { AuthenticationMode, createAuthenticationProvider } from "../HttpClient/AuthenticationMode";
import { ExceptionLogger, HttpClient } from "../HttpClient/HttpClient";

import { IPicklistApiClient } from "./IPicklistApiClient";
import { PicklistRequestV2 } from "./Types/PicklistRequestV2";
import { PicklistResultV2 } from "./Types/PicklistResultV2";

export class PicklistApiClient implements IPicklistApiClient {
    private readonly httpClient: IHttpClient;

    public constructor(
        fetchImpl: Fetch,
        baseUrl: string,
        resourceZone: undefined | string,
        authentication: undefined | AuthenticationMode,
        exceptionLogger?: ExceptionLogger
    ) {
        this.httpClient = new HttpClient(
            fetchImpl,
            baseUrl,
            createAuthenticationProvider(authentication),
            {
                resourceZone: resourceZone,
            },
            exceptionLogger
        );
    }

    public searchAsync(gid: string, request: Readonly<PicklistRequestV2>): Promise<PicklistResultV2> {
        const { filter, take, skip } = request;
        const picklistUrl = `v2/${request.tree ? "tree/" : ""}${gid}/`;
        return this.httpClient
            .get(picklistUrl)
            .withQueryParams({ filter: filter, take: take, skip: skip })
            .json<PicklistResultV2>();
    }
}
